import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-46">
      {/* Background glow effects */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-emerald-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-47" />
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-blue-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-48" />

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-50">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="inline-block px-4 py-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/10 text-emerald-400 text-sm font-semibold tracking-wide mb-6" data-id="element-51">
            NUEVO MÉTODO 2026
          </motion.div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6" data-id="element-52">
            Freelance Express: <br className="hidden md:block" data-id="element-53" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-blue-400" data-id="element-54">
              El Mapa para la Libertad en Dólares
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed max-w-2xl" data-id="element-55">
            Cómo generar tus primeros $500 USD mensuales trabajando desde casa
            sin ser experto, sin títulos y sin jefes.
          </p>

          <CTAButton data-id="element-56" />

          <div className="mt-6 flex items-center gap-2 text-sm text-gray-400" data-id="element-57">
            <span className="flex h-2 w-2 rounded-full bg-emerald-500 animate-pulse" data-id="element-58"></span>
            Acceso inmediato tras el pago
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-59">
          <motion.div animate={{
          y: [-10, 10, -10]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} className="relative z-10" data-id="element-60">
            <img src="https://cdn.magicpatterns.com/uploads/733nc6YCMUWzA9xv3foZVy/MOCKUP_OK.png" alt="Freelance Express Book Mockup" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(16,185,129,0.2)]" data-id="element-61" />
          </motion.div>

          {/* Decorative elements behind image */}
          <div className="absolute inset-0 bg-gradient-to-tr from-emerald-500/20 to-blue-500/20 blur-3xl -z-10 rounded-full transform scale-90" data-id="element-62" />
        </motion.div>
      </div>
    </section>;
}